module.exports = __webpack_public_path__ + "a7655557b98a6688b914e2f3cb5dfb2c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/march-marathon-medal.png
// module id = 1922
// module chunks = 0